export default {
	active_campaigns: "Campanhas Ativas",
	begin_date: "Data de Início",
	campaign: "Campanha",
	end_date: "Data de Término",
	learn_more_about_the_campaign_by_clicking: "Saiba mais sobre a campanha clicando",
	no_campaigns_found: "Nenhuma campanha encontrada",
	previous_campaigns: "Campanhas Anteriores",
	view_campaign: "Ver Campanha",
}